<template>
    <v-card class="pa-5 text-center">
        <h1 v-html="title" />
        <h2 class="primary--text my-3">Please check back soon!</h2>
    </v-card>
</template>

<script>
  export default {
    name: 'NoneFoundNotice',
    props: {
      title: String
    }
  }
</script>